import * as React from 'react';

export const ArrowUpRight = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M10.8877 10.0875L10.9124 3.08747M10.9124 3.08747L3.91237 3.11217M10.9124 3.08747L3.08738 10.9125"
      stroke="currentColor"
      strokeMiterlimit="10"
    />
  </svg>
);

export const ChevronLeft = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M9 11L5 7L9 3"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronRight = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M5 3L9 7L5 11"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Chevron = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    className={className}
    color="currentColor"
  >
    <path
      d="M19.8799 8.06055L11.9996 15.9407L4.11951 8.06055"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeMiterlimit="10"
    />
  </svg>
);

export const DropdownArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="11"
    viewBox="0 0 14 11"
    fill="none"
  >
    <path
      d="M12.2773 6.03193L0.558594 6.03158V0M12.2773 6.03193L8.25619 2.01077M12.2773 6.03193L8.2562 10.0531"
      stroke="white"
      strokeWidth="1.11702"
      strokeMiterlimit="10"
    />
  </svg>
);
